import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { notificationsImages } from '../../../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../../AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_PRIVATE_OFFER_PLATFORM_NOTIFICATIONS
        }
        question="What does private offer created notify me about?"
      />
    ),
    answer: (
      <div>
        When a private offer is created by you for a buyer, you will receive an
        email notification regarding its creation.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_PRIVATE_OFFER_PLATFORM_NOTIFICATIONS
        }
        question="What does private offer accepted notify me about?"
      />
    ),
    answer: (
      <div>
        When a buyer accepts a private offer sent by you, you will receive an
        email notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_PRIVATE_OFFER_PLATFORM_NOTIFICATIONS
        }
        question="What does private offer expired notify me about?"
      />
    ),
    answer: (
      <div>
        When a private offer sent by you to a buyer expires, you will receive an
        email notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_PRIVATE_OFFER_PLATFORM_NOTIFICATIONS
        }
        question="What does private offer cancelled notify me about?"
      />
    ),
    answer: (
      <div>
        When a private offer sent by you to a buyer is cancelled by you, you
        will receive an email notification regarding it.
      </div>
    ),
  },
]

interface PrivateOfferNotificationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const PrivateOfferNotificationFaqs: React.FC<
  PrivateOfferNotificationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Private Offer Platform Notifications"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={notificationsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
